export default __webpack_public_path__ + "static/media/ijdka_icon.ffde5124.png";